import { Route, Switch, Redirect } from 'react-router-dom';
import Authorize from '../../components/Authorize';
import { Provider } from 'react-redux';
import React from 'react';
import { ConnectedRouter as Router } from 'connected-react-router';
import ThemeProvider from '@rezdy/components/ThemeWrapper';
import history from '../../services/history';
import login from '../../services/login';
import routes from '../routes';
import store from '../../store/configureStore';
import gtm from '../../services/gmt';

class App extends React.PureComponent {
    componentDidMount() {
        gtm.render();
    }

    render() {
        return (
            <ThemeProvider>
                <Provider store={store}>
                    <Authorize login={login}>
                        <Router history={history}>
                            <Switch>
                                {routes.map(route => (
                                    <Route key={route.to} path={route.to} component={route.component} exact={true} />
                                ))}
                                <Redirect to="/createCompany" />
                            </Switch>
                        </Router>
                    </Authorize>
                </Provider>
            </ThemeProvider>
        );
    }
}

export default App;
